import axiosInstance from '../RestClient';

const BASE_URI = '/historyLogs';

class HistoryLogsService {
	async list() {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listFromId(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listChildrenFromId(model, recordId) {
		const uri = `${BASE_URI}/children/${model}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listModels() {
		const uri = `${BASE_URI}/models`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async search(params = {}) {
		const uri = `${BASE_URI}/search`;
		const response = await axiosInstance.get(uri, { params });
		return response;
	}

	async getRecent(limit = 20) {
		const uri = `${BASE_URI}/recent?limit=${limit}`;
		const response = await axiosInstance.get(uri);
		return response;
	}
}
export default new HistoryLogsService();
